"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAAS_TOKEN_KEY = exports.MKP_TOKEN_KEY = exports.init = void 0;
var wrapper_1 = __importDefault(require("./utils/wrapper"));
var constant_1 = require("./utils/constant");
Object.defineProperty(exports, "MKP_TOKEN_KEY", { enumerable: true, get: function () { return constant_1.MKP_TOKEN_KEY; } });
Object.defineProperty(exports, "SAAS_TOKEN_KEY", { enumerable: true, get: function () { return constant_1.SAAS_TOKEN_KEY; } });
// Optim:  clients<Auth> / clients<Customer>...
var init = function (options) {
    return wrapper_1.default.init(options);
};
exports.init = init;
__exportStar(require("./model"), exports);
exports.default = { init: exports.init };
